import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  hide() {
    this.contentTarget.classList.add("hidden");
  }
}